// extracted by mini-css-extract-plugin
export var alertIcon = "_nk-0";